import {Component, OnInit} from '@angular/core';
import {SearchComponent} from '../search/search.component';

declare var $: any;

@Component({
  selector: 'cmp-animated-search',
  template: `<div class="clearfix">
  <div class="animated-search">
    <div class="form-group input-search mb-0" [id]="id">
      <cmp-input (ngModelChange)="model = $event;filterBySearch()"></cmp-input>
    </div>
    <cmp-button-icon (click)="showSearch()"
                     [type]="enum_type.ROUNDED_REGULAR"
                     [icon]="'fa fa-search'">
    </cmp-button-icon>
  </div>
</div>
`,
  styles: [`.animated-search{float:right}.animated-search .form-group{float:left;display:none;margin-right:5px}`]
})
export class AnimatedSearchComponent extends SearchComponent implements OnInit {

  id = this.id_crazy;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  showSearch() {
    $(('#' + this.id)).animate({width: 'toggle'});
  }
}
